(function() {
  function getHeaderOffset() {
    const header = document.querySelector('.shopify-section-header, header, .header-wrapper, .header');
    const headerHeight = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
    return headerHeight + 12;
  }

  function findAnchorTarget(anchorId) {
    const normalized = (anchorId || '').trim().replace(/^#/, '');
    if (!normalized) return null;

    const direct = document.getElementById(normalized);
    if (direct) return direct;

    const prefixedId = normalized.indexOf('shopify-section-') === 0 ? normalized : 'shopify-section-' + normalized;
    const prefixed = document.getElementById(prefixedId);
    if (prefixed) return prefixed;

    const sectionEls = document.querySelectorAll('[id^="shopify-section-"]');
    for (let i = 0; i < sectionEls.length; i += 1) {
      const currentId = sectionEls[i].id || '';
      if (currentId.endsWith('__' + normalized)) {
        return sectionEls[i];
      }
    }

    return null;
  }

  function scrollToAnchor(anchorId) {
    const target = findAnchorTarget(anchorId);
    if (!target) return false;

    const offsetTop = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();
    window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    return true;
  }

  function getRaisedImageCoverRatio(raisedBlock) {
    if (raisedBlock.classList.contains('bsg-flexible-columns-2__raised--image-50')) return 0.3;
    if (raisedBlock.classList.contains('bsg-flexible-columns-2__raised--image-75')) return 0.1;
    return 0.2;
  }

  function updateRaisedTextOverlap(raisedBlock) {
    const media = raisedBlock.querySelector('.bsg-flexible-columns-2__raised-media');
    if (!media) return;

    const mediaHeight = media.getBoundingClientRect().height;
    const overlap = Math.max(0, Math.round(mediaHeight * getRaisedImageCoverRatio(raisedBlock)));
    raisedBlock.style.setProperty('--bsg-flexible-columns-2-stack-overlap', overlap + 'px');
  }

  function initRaisedTextOverlap(sectionRoot) {
    sectionRoot.querySelectorAll('.bsg-flexible-columns-2__raised').forEach(function(raisedBlock) {
      updateRaisedTextOverlap(raisedBlock);

      if (raisedBlock.dataset.bsgFlexibleColumns2OverlapInitialized === 'true') return;
      raisedBlock.dataset.bsgFlexibleColumns2OverlapInitialized = 'true';

      const media = raisedBlock.querySelector('.bsg-flexible-columns-2__raised-media');
      if (!media) return;

      media.querySelectorAll('img, video').forEach(function(mediaEl) {
        mediaEl.addEventListener('load', function() {
          updateRaisedTextOverlap(raisedBlock);
        });
        mediaEl.addEventListener('loadedmetadata', function() {
          updateRaisedTextOverlap(raisedBlock);
        });
      });

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(function() {
          updateRaisedTextOverlap(raisedBlock);
        });
        observer.observe(media);
        raisedBlock._bsgFlexibleColumns2ResizeObserver = observer;
      }
    });
  }

  function initFlexibleColumns2(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.bsgFlexibleColumns2Initialized === 'true') return;
    sectionRoot.dataset.bsgFlexibleColumns2Initialized = 'true';

    initRaisedTextOverlap(sectionRoot);

    sectionRoot.querySelectorAll('[data-bsg-flexible-columns-2-anchor]').forEach(function(trigger) {
      trigger.addEventListener('click', function(event) {
        const anchorId = trigger.getAttribute('data-bsg-flexible-columns-2-anchor');
        if (scrollToAnchor(anchorId)) event.preventDefault();
      });
    });
  }

  function initFloatingNavigation(root) {
    if (!root || root.dataset.bsgFlexibleColumns2FloatingNavInitialized === 'true') return;

    const sourceSectionId = root.getAttribute('data-bsg-flexible-columns-2-source-section');
    const sourceSection = document.getElementById(sourceSectionId);
    if (!sourceSection) return;

    root.dataset.bsgFlexibleColumns2FloatingNavInitialized = 'true';

    let activePanel = 'main';
    let frame = null;
    let lastScrollY = window.scrollY;
    let mobileVisibleAtY = window.scrollY;
    let manuallyCollapsed = false;
    let userHasOpenedFlexibleDropdown = false;
    const collapseButton = root.querySelector('[data-bsg-flexible-columns-2-nav-collapse]');
    const exploreTrigger = root.querySelector('[data-bsg-flexible-columns-2-nav-open="explore"]');
    const collapseDropdownsRow = root.querySelector('[data-bsg-flexible-columns-2-collapse-dropdowns-row]');
    const collapseDropdownsButton = root.querySelector('[data-bsg-flexible-columns-2-collapse-dropdowns]');

    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function isDesktop() {
      return window.matchMedia('(min-width: 750px)').matches;
    }

    function desktopIsTight() {
      return window.matchMedia('(min-width: 750px) and (max-width: 1199px)').matches || root.dataset.bsgFlexibleColumns2FloatingNavContentTight === 'true';
    }

    function headerMenuOpen() {
      const menu = document.getElementById('Details-menu-drawer-container');
      return document.body.classList.contains('overflow-hidden-mobile') || (menu && (menu.hasAttribute('open') || menu.classList.contains('menu-opening')));
    }

    function setVisible(visible) {
      const wasVisible = root.classList.contains('bsg-flexible-columns-2-floating-nav--visible');
      root.classList.toggle('bsg-flexible-columns-2-floating-nav--visible', visible);
      root.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('bsg-flexible-columns-2-floating-nav-visible', visible);
      if (visible && !wasVisible && isMobile()) mobileVisibleAtY = window.scrollY;
    }

    function updateVisibility() {
      const footer = document.querySelector('footer');
      const footerReached = footer && footer.getBoundingClientRect().top <= window.innerHeight;
      const openingSectionPassed = sourceSection.getBoundingClientRect().bottom <= getHeaderOffset();
      setVisible((isMobile() || isDesktop()) && openingSectionPassed && !headerMenuOpen() && !footerReached);
    }

    function setCollapsed(collapsed) {
      root.classList.toggle('bsg-flexible-columns-2-floating-nav--collapsed', collapsed);
      if (!collapseButton) return;
      collapseButton.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      collapseButton.setAttribute('aria-label', collapsed ? 'Expand page navigation' : 'Collapse page navigation');
    }

    function syncPanelHeight() {
      if (!isMobile()) return;
      const panel = root.querySelector('[data-bsg-flexible-columns-2-nav-panel="' + activePanel + '"]');
      if (!panel) return;
      const maxHeight = Math.min(window.innerHeight * 0.74, 600) - 32;
      root.style.setProperty('--bsg-flexible-columns-2-floating-nav-panel-height', Math.min(panel.scrollHeight, maxHeight) + 'px');
    }

    function getOpenFlexibleDropdowns() {
      return Array.from(document.querySelectorAll('[data-bsg-flexible-dropdown-item][open]'));
    }

    function syncCollapseDropdownsButton() {
      if (!collapseDropdownsRow) return;
      const hasOpenDropdowns = getOpenFlexibleDropdowns().length > 0;
      if (!hasOpenDropdowns) userHasOpenedFlexibleDropdown = false;
      collapseDropdownsRow.hidden = !isDesktop() || !userHasOpenedFlexibleDropdown || !hasOpenDropdowns;
    }

    function setPanel(panel, preserveCollapse) {
      if (!preserveCollapse) setCollapsed(false);
      activePanel = panel;
      root.setAttribute('data-bsg-flexible-columns-2-nav-active', panel);
      if (exploreTrigger) exploreTrigger.setAttribute('aria-expanded', panel === 'explore' ? 'true' : 'false');

      root.querySelectorAll('[data-bsg-flexible-columns-2-nav-panel]').forEach(function(element) {
        const panelName = element.getAttribute('data-bsg-flexible-columns-2-nav-panel');
        const isActive = panelName === panel;
        const keepDesktopMain = isDesktop() && panel === 'explore' && panelName === 'main';
        element.setAttribute('aria-hidden', (isActive || keepDesktopMain) ? 'false' : 'true');
        element.inert = !isActive && !keepDesktopMain;
      });

      window.requestAnimationFrame(syncPanelHeight);
    }

    function syncDesktopCompact() {
      const wasCompact = root.classList.contains('bsg-flexible-columns-2-floating-nav--compact');
      const compact = isDesktop() && desktopIsTight();
      root.classList.toggle('bsg-flexible-columns-2-floating-nav--compact', compact);

      if (compact) {
        setCollapsed(true);
      } else if (wasCompact && !manuallyCollapsed) {
        setCollapsed(false);
      }
    }

    function syncDesktopPosition() {
      if (!isDesktop()) return;

      let widestRect = null;
      let widestWidth = 0;
      let sibling = sourceSection.nextElementSibling;

      while (sibling) {
        if (sibling.matches('footer, .shopify-section-group-footer-group') || sibling.querySelector('footer')) break;

        const candidates = [];
        if (sibling.matches('.page-width')) candidates.push(sibling);
        sibling.querySelectorAll('.page-width').forEach(function(candidate) {
          candidates.push(candidate);
        });

        candidates.forEach(function(candidate) {
          const rect = candidate.getBoundingClientRect();
          if (rect.width > widestWidth && rect.width > 0) {
            widestWidth = rect.width;
            widestRect = rect;
          }
        });

        sibling = sibling.nextElementSibling;
      }

      if (!widestRect) {
        const fallback = sourceSection.querySelector('.page-width');
        if (fallback) widestRect = fallback.getBoundingClientRect();
      }

      if (!widestRect) return;
      const availableGutter = Math.max(0, window.innerWidth - widestRect.right);
      const navigationWidth = root.offsetWidth || 185;
      const desiredGap = 16;
      const unavoidableOverlap = Math.max(0, navigationWidth + desiredGap - availableGutter);
      const rightOffset = Math.max(12, Math.round(availableGutter - navigationWidth - desiredGap));

      root.dataset.bsgFlexibleColumns2FloatingNavContentTight = unavoidableOverlap > navigationWidth * 0.35 ? 'true' : 'false';
      root.style.setProperty('--bsg-flexible-columns-2-floating-nav-right', rightOffset + 'px');
    }

    function requestUpdate() {
      if (frame) return;
      frame = window.requestAnimationFrame(function() {
        frame = null;
        updateVisibility();
      });
    }

    root.querySelectorAll('[data-bsg-flexible-columns-2-nav-open]').forEach(function(button) {
      button.addEventListener('click', function() {
        const panel = button.getAttribute('data-bsg-flexible-columns-2-nav-open');
        manuallyCollapsed = false;
        if (isDesktop() && activePanel === panel) {
          setPanel('main');
          return;
        }
        setPanel(panel);
      });
    });

    root.querySelectorAll('[data-bsg-flexible-columns-2-nav-back]').forEach(function(button) {
      button.addEventListener('click', function() {
        manuallyCollapsed = false;
        setPanel('main');
      });
    });

    root.querySelectorAll('[data-bsg-flexible-columns-2-anchor]').forEach(function(trigger) {
      trigger.addEventListener('click', function(event) {
        const anchorId = trigger.getAttribute('data-bsg-flexible-columns-2-anchor');
        if (!scrollToAnchor(anchorId)) return;
        event.preventDefault();
        manuallyCollapsed = false;
        setPanel('main');
        if (isMobile()) setCollapsed(true);
      });
    });

    root.querySelectorAll('[data-bsg-flexible-columns-2-return-top]').forEach(function(button) {
      button.addEventListener('click', function() {
        manuallyCollapsed = false;
        setPanel('main');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });

    if (collapseDropdownsButton) {
      collapseDropdownsButton.addEventListener('click', function() {
        getOpenFlexibleDropdowns().forEach(function(dropdown) {
          dropdown.open = false;
        });
        userHasOpenedFlexibleDropdown = false;
        syncCollapseDropdownsButton();
      });
    }

    document.addEventListener('click', function(event) {
      const summary = event.target.closest && event.target.closest('[data-bsg-flexible-dropdown-item] > summary');
      if (!summary) return;
      const dropdown = summary.parentElement;
      if (dropdown && !dropdown.open) userHasOpenedFlexibleDropdown = true;
    }, true);

    document.addEventListener('toggle', function(event) {
      if (!event.target.matches || !event.target.matches('[data-bsg-flexible-dropdown-item]')) return;
      syncCollapseDropdownsButton();
    }, true);

    if (collapseButton) {
      collapseButton.addEventListener('click', function() {
        const isCollapsed = root.classList.contains('bsg-flexible-columns-2-floating-nav--collapsed');
        manuallyCollapsed = !isCollapsed;
        setPanel('main', !isCollapsed);
        if (!isCollapsed) setCollapsed(true);
      });
    }

    window.addEventListener('scroll', function() {
      const nextScrollY = window.scrollY;
      const delta = nextScrollY - lastScrollY;

      if (isMobile() && root.classList.contains('bsg-flexible-columns-2-floating-nav--visible') && activePanel === 'main') {
        if (delta > 14 && nextScrollY - mobileVisibleAtY >= 120) setCollapsed(true);
        if (delta < -14 && !manuallyCollapsed) setCollapsed(false);
      }

      lastScrollY = nextScrollY;
      requestUpdate();
    }, { passive: true });

    window.addEventListener('resize', function() {
      requestUpdate();
      syncPanelHeight();
      syncDesktopPosition();
      syncDesktopCompact();
      syncCollapseDropdownsButton();
    });

    document.addEventListener('shopify:section:load', function() {
      requestUpdate();
      syncDesktopPosition();
    });

    setPanel('main');
    syncDesktopPosition();
    syncDesktopCompact();
    syncCollapseDropdownsButton();
    requestUpdate();
  }

  function initAllFlexibleColumns2(root) {
    const scope = root || document;

    if (scope.matches && scope.matches('[data-bsg-flexible-columns-2-floating-nav]')) {
      initFloatingNavigation(scope);
    }

    scope.querySelectorAll('[data-bsg-flexible-columns-2-floating-nav]').forEach(function(floatingNavigation) {
      initFloatingNavigation(floatingNavigation);
    });

    if (scope.matches && scope.matches('.shopify-section') && scope.querySelector('[data-bsg-flexible-columns-2]')) {
      initFlexibleColumns2(scope);
    }

    scope.querySelectorAll('.shopify-section').forEach(function(sectionRoot) {
      if (sectionRoot.querySelector('[data-bsg-flexible-columns-2]')) {
        initFlexibleColumns2(sectionRoot);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAllFlexibleColumns2(document);
    });
  } else {
    initAllFlexibleColumns2(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAllFlexibleColumns2(event.target);
  });

  window.addEventListener('resize', function() {
    document.querySelectorAll('[data-bsg-flexible-columns-2]').forEach(function(sectionRoot) {
      initRaisedTextOverlap(sectionRoot);
    });
  });
})();
